import { DEFAULT_PLAZA_TELEMETRY_TIMEOUT } from './actions';

export const defaultState = {
  currentChart: null,
  userSettings: {
    showPhases: true,
    showEnergyFlow: false,
  },
  plaza: null,
  viewingNode: {
    id: null,
    data: null,
  },
  zoom: 0,
  minimapExpanded: true,
  schemaParams: {
    initialWidth: 15,
    initialHeight: 15,
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    scrollLeft: 0,
    scrollTop: 0,
  },
  availablePlazaTemplates: [],
  telemetryTimeout: DEFAULT_PLAZA_TELEMETRY_TIMEOUT,
  activeViews: [],
  columnsConfig: [],
};

function plazaView(state = defaultState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return defaultState;
    case 'SET_CURRENT_CHART':
      return { ...state, currentChart: action.currentChart };
    case 'PLAZA_LOADED':
      return { ...state, plaza: action.plaza };
    case 'SET_PLAZA_TOPOLOGY_NODES':
      return { ...state, plaza: { ...state.plaza, topologyNodes: action.payload } };
    case 'SET_USER_SETTINGS':
      return { ...state, userSettings: action.payload };
    case 'SET_DEFAULT_USER_SETTINGS':
      return { ...state, userSettings: defaultState.userSettings };
    case 'SET_VIEWING_NODE_ID':
      return { ...state, viewingNode: { id: action.payload, data: null } };
    case 'SET_VIEWING_NODE_DATA':
      return { ...state, viewingNode: { ...state.viewingNode, data: action.payload } };
    case 'SET_ZOOM':
      return { ...state, zoom: action.payload.zoom };
    case 'SET_MINIMAP_EXPANDED':
      return { ...state, minimapExpanded: action.payload.expanded };
    case 'SET_SCHEMA_PARAMS':
      return { ...state, schemaParams: { ...state.schemaParams, ...action.payload.params } };
    case 'SET_AVAILABLE_PLAZA_TEMPLATES': {
      return { ...state, availablePlazaTemplates: action.payload.templates };
    }
    case 'SET_PLAZA_TELEMETRY_TIMEOUT':
      return { ...state, telemetryTimeout: action.payload };
    case 'SET_PLAZA_MONITOR_VIEW': {
      if (state.activeViews.find((item) => item.plazaId === action.payload.id)) {
        return {
          ...state,
          activeViews: state.activeViews.map((item) => ({
            ...item,
            view: (item.plazaId === action.payload.id) ? action.payload.view : item.view,
          })),
        };
      }

      return {
        ...state,
        activeViews: [
          ...state.activeViews,
          { plazaId: action.payload.id, view: action.payload.view },
        ],
      };
    }
    case 'RESET_PLAZA_MONITOR_VIEW':
      return { ...state, activeViews: [] };
    case 'SET_TABLE_VIEW_COLUMNS_CONFIG':
      return { ...state, columnsConfig: action.payload };
    default:
      return state;
  }
}

export default plazaView;
